import { PerfilNormalizado } from '../shared/enums/perfil-normalizado.enum';

export class AcessoRapido {
    private constructor(
        public title: string,
        public url: string,
        public imageUrl: string,
        public important: number
    ) { }

    /*importante 1- mais importante e 10- menos importante*/
    private static atalhos: AcessoRapido[] = [];

    public static init(
        perfis: PerfilNormalizado[],
        quantity: number
    ): AcessoRapido[] {
        this.atalhos = [];

        perfis.forEach(perfil => {
            this.load(perfil);
        });

        this.atalhos = this.atalhos
            .sort((a, b) => a.important - b.important)
            .slice(0, quantity);
        return this.atalhos;
    }

    public static load(perfilNormalizado: PerfilNormalizado) {
        switch (perfilNormalizado) {
            case PerfilNormalizado.Responsavel:
                this.loadAcessosRapidosResponsavel();
                break;
            case PerfilNormalizado.Cadastro:
                this.loadAcessosRapidosCadastro();
                break;
            case PerfilNormalizado.Administrativo:
                this.loadAcessosRapidosAdministrativo();
                break;
            case PerfilNormalizado.Financeiro:
                this.loadAcessosRapidosFinanceiro();
                break;
            case PerfilNormalizado.Beneficio:
                this.loadAcessosRapidosBeneficio();
                break;
            case PerfilNormalizado.Pedido:
                this.loadAcessosRapidosPedido();
                break;
        }
    }

    public static loadAcessosRapidosResponsavel() {
        this.loadAcessosRapidosCadastro();
        this.loadAcessosRapidosAdministrativo();
        this.loadAcessosRapidosFinanceiro();
        this.loadAcessosRapidosBeneficio();
        this.loadAcessosRapidosPedido();
    }

    public static loadAcessosRapidosCadastro() {
        this.atalhos.push(
            new AcessoRapido(
                'Centros de custo',
                '/portal/centrocusto',
                './assets/icons/cadastro/icon-centro-custo.svg',
                5
            )
        );
        this.atalhos.push(
            new AcessoRapido(
                'Favorecidos',
                '/portal/colaborador',
                './assets/icons/cadastro/icon-colaborador.svg',
                2
            )
        );

        this.atalhos.push(
            new AcessoRapido(
                'Unidades',
                '/portal/unidade',
                './assets/icons/cadastro/icon-unidade.svg',
                5
            )
        );
        this.atalhos.push(
            new AcessoRapido(
                'Departamentos',
                '/portal/departamento',
                './assets/icons/cadastro/icon-departamento.svg',
                5
            )
        );
    }

    public static loadAcessosRapidosAdministrativo() {
        this.atalhos.push(
            new AcessoRapido(
                'Gestores',
                '/portal/gestor',
                './assets/icons/administrativo/icon-gestor.svg',
                4
            )
        );
        this.atalhos.push(
            new AcessoRapido(
                'Dados bancários',
                '/portal/dadobancario',
                './assets/icons/administrativo/icon-dado-bancario.svg',
                5
            )
        );
        this.atalhos.push(
            new AcessoRapido(
                'Dados da empresa',
                '/portal/dadoempresa',
                './assets/icons/administrativo/icon-dado-empresa.svg',
                5
            )
        );
    }

    public static loadAcessosRapidosFinanceiro() {
        // TODO
    }

    public static loadAcessosRapidosBeneficio() {
        // mesmo que produto
        this.atalhos.push(
            new AcessoRapido(
                'Contratar novo incentivo',
                '/portal/novobeneficio/contratar',
                './assets/icons/produtos/icon-contratar-novo-beneficio.svg',
                3
            )
        );
        this.atalhos.push(
            new AcessoRapido(
                'Visualizar produtos aderidos',
                '/portal/contrato/contratos',
                './assets/icons/produtos/icon-visualizar-meus-contratos.svg',
                3
            )
        );
        // this.atalhos.push(new AcessoRapido('Reajustar incentivos (em lote)', '', '', 5));
        // this.atalhos.push(new AcessoRapido('Consultar incentivos', '', '', 5));
    }

    public static loadAcessosRapidosPedido() {
        this.atalhos.push(
            new AcessoRapido(
                'Meus pedidos',
                '/portal/meuspedidos',
                './assets/icons/pedidos/icon-meus-pedidos.svg',
                1
            )
        );
        this.atalhos.push(
            new AcessoRapido(
                'Novo pedido',
                '/portal/novopedido/create',
                './assets/icons/pedidos/icon-novo-pedido.svg',
                1
            )
        );
    }
}
